import { useEffect, useRef, useState } from 'react';
import { Box, Text } from '@primer/react';
import { CALENDLY_URL, trackContactClick } from '../utils/links';

function ConsultationCTA() {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.unobserve(node);
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Box
      ref={sectionRef}
      sx={{
        position: 'relative',
        width: '100%',
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingX: 4,
        overflow: 'hidden',
      }}
    >
      {/* smooths the seam between the dark section above and this section's white background */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '120px',
          background: 'linear-gradient(to bottom, #0d1117 0%, rgba(13, 17, 23, 0) 100%)',
          pointerEvents: 'none',
        }}
      />

      <Box
        sx={{
          position: 'relative',
          maxWidth: '1000px',
          margin: '0 auto',
          textAlign: 'center',
          opacity: inView ? 1 : 0,
          transform: inView ? 'translateY(0)' : 'translateY(40px)',
          transition: 'opacity 0.9s ease-out, transform 0.9s ease-out',
        }}
      >
        <Text
          as="p"
          sx={{
            margin: 0,
            fontFamily: "'Fraunces', serif",
            fontWeight: 300,
            fontSize: ['2.25rem', '3.25rem', '4.25rem'],
            lineHeight: 1.25,
            color: '#1b1f24',
          }}
        >
          Enough about us, what can we do for you?
        </Text>

        <Box
          as="a"
          href={CALENDLY_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={trackContactClick}
          sx={{
            display: 'inline-block',
            textDecoration: 'none',
            marginTop: 5,
            paddingX: 5,
            paddingY: 3,
            borderRadius: '6px',
            border: '1px solid rgba(27, 31, 36, 0.15)',
            backgroundColor: '#1f883d',
            color: '#ffffff',
            fontSize: 1,
            fontWeight: 600,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            cursor: 'pointer',
            transitionDelay: '0.15s',
            transitionProperty: 'opacity, transform, background-color',
            transitionDuration: '0.9s, 0.9s, 0.15s',
            transitionTimingFunction: 'ease-out',
            opacity: inView ? 1 : 0,
            transform: inView ? 'translateY(0)' : 'translateY(40px)',
            ':hover': { backgroundColor: '#1c8139' },
            ':active': { backgroundColor: '#197935' },
          }}
        >
          Tell us about yourself
        </Box>
      </Box>
    </Box>
  );
}

export default ConsultationCTA;
